const { NODE_ENV: env } = process.env

const backendUrl =
  env === "development"
    ? "http://localhost:8080/v1/"
    : "https://ventas.lawcorp.com.mx/v1/"
export { backendUrl }
